import { Pipe } from '@angular/core';
var IsIdenticalToPipe = (function () {
    function IsIdenticalToPipe() {
    }
    IsIdenticalToPipe.prototype.transform = function (input, other) {
        return input === other;
    };
    return IsIdenticalToPipe;
}());
export { IsIdenticalToPipe };
IsIdenticalToPipe.decorators = [
    { type: Pipe, args: [{ name: 'isIdenticalTo' },] },
];
/** @nocollapse */
IsIdenticalToPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-identical-to.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-identical-to.js
// module id = 224
// module chunks = 4